export const main = {
  notice: 'Bestel- en beheeroplossingen voor restaurants',
  notice_2: 'een website of webshop voor jouw restaurant in enkele minuten',

  logo_alt: 'Bistroo',
  login_text: 'Log in',
  login_text_mobile: 'Restaurant log in',
  start_free_text: 'Start gratis',

  actions: {
    create_your_shop: 'Maak je webshop',
    product_demo: 'Product demo',
  },

  menu: {
    home: {
      text: 'Home',
    },
    products: {
      text: 'Producten',
      submenu: {
        manager: {
          text: 'Bistroo Manager',
          subtext: 'Alle tools volledig in eigen beheer',
        },
        qr: {
          text: 'Bistroo QR',
          subtext: 'Een kostenefficiënt tafelbestelproces',
        },
        webshop: {
          text: 'Bistroo Webshop',
          subtext: 'De webshop voor jou restaurant',
        },
        pos: {
          text: 'Bistroo Kassa',
          subtext: 'Supersnelle kassa voor quick-service',
        },
        posdevice: {
          text: 'Bistroo Device',
          subtext: 'Plug & play bestellen en printen',
        },
        page: {
          text: 'Bistroo Website',
          subtext: 'Maak binnen minuten een website',
        },
        kiosk: {
          text: 'Bistroo Kiosk',
          subtext: 'Zelfbediening in jouw restaurant',
        },
      },
    },
    prices: {
      text: 'Prijzen',
    },
    cases: {
      text: 'Cases',
      submenu: {
        cafetaria: {
          text: "Cafetaria D'n Boom",
          subtext: 'Hoe Bistroo hielp de omzet te vergroten.',
        },
        grillroom: {
          text: 'Grillroom Instanbul',
          subtext: 'Eindelijk een eerlijk verdienmodel.',
        },
        sushi: {
          text: 'Sushi De wethouder',
          subtext: 'Een partner die we 24/7 kunnen vertrouwen.',
        },
        italian: {
          text: 'Italiaan Il Municipio',
          subtext: 'Een nieuwe oplossing en mogelijkheden.',
        },
        lunchroom: {
          text: 'Lunchroom Two-B',
          subtext: 'We hebben veel tijd en frustratie bespaard.',
        },
      },
    },
    info: {
      text: 'Info',
      submenu: {
        helpcenter: {
          text: 'Helpcentrum',
          subtext: 'Alle informatie die je nodig hebt',
        },
        integrations: {
          text: 'Integraties',
          subtext: 'Onze partnerintegraties',
        },
        downloads: {
          text: 'Downloads',
          subtext: 'De laatste app-updates',
        },
        articles: {
          text: 'Artikelen',
          subtext: 'Laatste branche-updates',
        },
        faq: {
          text: 'FAQ',
          subtext: 'Meestgestelde vragen',
        },
        blog: {
          text: 'Blog',
          subtext: 'Actuele info & trends',
        },
        support: {
          text: 'Klantenservice',
          subtext: 'We helpen je graag verder',
        },
        contact: {
          text: 'Contact',
          subtext: 'We helpen je graag verder',
        },
      },
    },
  },
  cta_block: {
    open_your_webshop_today: 'Open vandaag je shop.',
    its_free: 'Het is gratis!',
    start_generating_more_orders: 'Genereer binnen enkele minuten je eerste bestelling',
    get_started_for_free: 'Start gratis',
  },
  footer: {
    general: 'Algemeen',
    products: 'Producten',
    cases: 'Cases',
    info: 'Informatie',
  },
  product_faq: {
    label: 'Veelgestelde vragen',
    not_listed: 'Staat jouw vraag er niet bij? Neem dan contact op met ons supportteam.',
  },
  integration: {
    back_link: 'Alle integraties',
    advantages_label: 'Voordelen',
    setup_label: 'Instellen in 5 stappen',
    faq_heading: 'Veelgestelde vragen',
    more_info: 'Meer info',
    check_1: 'Vrijblijvend en maandelijks opzegbaar',
    check_2: 'Instellen in enkele minuten',
    advantages_subtitle: 'Krachtige functies die naadloos samenwerken voor jouw restaurantactiviteiten',
    cta_footer_text: 'Instellen in minder dan 10 minuten · Maandelijks opzegbaar',
    related: {
      eyebrow: 'Bekijk ook',
      title: 'Gerelateerde integraties',
      description: 'Bistroo werkt samen met de beste tools. Combineer meerdere integraties voor een volledig geautomatiseerde horecaoperatie.',
    },
    cta: {
      heading: 'Open je webshop vandaag nog.',
      free: 'Gratis.',
      subtext: 'Meer bestellingen, minder werk.',
      button: 'Gratis aan de slag',
    },
  },
}
